import { render, staticRenderFns } from "./specialSubjectRegistrationBox.vue?vue&type=template&id=bf065792"
import script from "./specialSubjectRegistrationBox.vue?vue&type=script&lang=js"
export * from "./specialSubjectRegistrationBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports